import { render, staticRenderFns } from "./TheHeaderDropdownNotifications.vue?vue&type=template&id=03727c9a&scoped=true"
import script from "./TheHeaderDropdownNotifications.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownNotifications.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownNotifications.vue?vue&type=style&index=0&id=03727c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03727c9a",
  null
  
)

export default component.exports